import { PropsWithChildren } from 'react';
import { Typography } from '@design-system/components/typography/typography';

export const PageWrapper = (p: PropsWithChildren) => (
  <div className="h-[calc(100%-40px)] max-w-[1600px]">
    <div className="flex flex-col gap-4 md:flex-row justify-between">
      <div className="flex items-center gap-4">
        <Typography variant="headline" size="large" id="page-title">
          Offers
        </Typography>
      </div>
    </div>
    <div className="my-5 2xl:my-10 h-full">{p.children}</div>
  </div>
);
